import Vue from "vue";

//注册全局组件 - components
import Button from "@/components/Button.vue";
import ConfirmPayMy from "@/components/button/confirm-pay-my";
import CopyImg from "@/components/CopyImg/Index.vue";
import NftInfo from "@/components/NftInfo/index";
import NftPayAmountBottom from "@/components/NftPayAmount-bottom/index";
import PayMethodInfo from "@/components/PayMethodInfo/index";
import IncludedDetails from "@/components/IncludedDetails/IncludedDetails";
import PaymentInstructions from "@/components/PaymentInstructions/index";
import PayFormInfo from "@/components/PayFormInfo/index";
Vue.component("Button", Button);
Vue.component("ConfirmPayMy", ConfirmPayMy);
Vue.component("CopyImg", CopyImg);
Vue.component("NftInfo", NftInfo);
Vue.component("NftPayAmountBottom", NftPayAmountBottom);
Vue.component("PayMethodInfo", PayMethodInfo);
Vue.component("IncludedDetails", IncludedDetails);
Vue.component("PaymentInstructions", PaymentInstructions);
Vue.component("PayFormInfo", PayFormInfo);

//ui - element
import "element-ui/lib/theme-chalk/index.css";
import { Popover, InfiniteScroll, Checkbox } from "element-ui";
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
Vue.use(Popover);
Vue.use(InfiniteScroll);
Vue.use(Checkbox);
Vue.component(CollapseTransition.name, CollapseTransition);
